import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donations/scrap-donations";

export const Route = createFileRoute("/admin/_donations/scrap-donations")({
  component: Page,
});
